import { useState, useCallback, useEffect } from 'react'

// Remembers the selected row per section so your place survives saves and refreshes.
export function useRowSelection(sectionKey) {
  const storeKey = `sel_row_${sectionKey}`
  const [selectedId, setSelectedId] = useState(() => {
    try {
      const v = localStorage.getItem(storeKey)
      return v ? Number(v) : null
    } catch { return null }
  })

  useEffect(() => {
    try {
      if (selectedId == null) localStorage.removeItem(storeKey)
      else localStorage.setItem(storeKey, String(selectedId))
    } catch {}
  }, [selectedId, storeKey])

  const select = useCallback((id) => {
    setSelectedId(prev => prev === id ? null : id)   // click again to deselect
  }, [])

  const rowProps = useCallback((id, onOpen) => ({
    className: selectedId === id ? 'row-selected' : undefined,
    onClick: () => select(id),
    onDoubleClick: onOpen ? (e) => { e.stopPropagation(); onOpen() } : undefined,
  }), [selectedId, select])

  return { selectedId, select, rowProps, clear: () => setSelectedId(null) }
}
